import { render, staticRenderFns } from "./referralLogin.vue?vue&type=template&id=44b420c6&"
import script from "./referralLogin.vue?vue&type=script&lang=js&"
export * from "./referralLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports